import { ResourceType } from './resource-type';

/**
 * The resource type for HierarchicalBrowseDefinition
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const HIERARCHICAL_BROWSE_DEFINITION = new ResourceType('hierarchicalBrowse');
